<template>
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :isHidden="isHidden"
      :label="label"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
      v-on:toggle-field="showSettings=!showSettings"
      v-on:collapse-field="collapse=!collapse"
    />
    <!-- input content -->

    <b-collapse
      class="card mt-5"
      id="collapse-1"
      v-show="JSON.parse(!fieldData.isHidden) || !isPreview"
      v-model="collapse"
    >
      <!-- v-if="fieldData.isConditional=='1'" -->

      <b-row v-if="fieldData.isConditional == 1 && !isPreview">
        <b-col cols="12" class="text-right">
          <b-button
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <div
        :class="$store.state.rightAlign ? 'card-body text-right' : 'card-body text-left'"
        :id="fieldData.id"
      >
        <h4>{{fieldData.registeredLabel[selectedLanguage]}}</h4>
        <p>{{fieldData.registeredDescription[selectedLanguage]}}</p>
        <!-- v-model="fieldData.isNa" -->
        <b-form-checkbox
          v-model="fieldData.isNa"
          @input="onClilckNa"
          value="1"
          unchecked-value="0"
        >N/A</b-form-checkbox>
        <!-- <h2>Registered / Incorporation Address</h2> -->

        <!-- ------------------------row 1 -->
        <div class="form-row" :id="fieldData.id">
          <div
            class="col-md-6"
            v-show="!fieldData.advance || !fieldData.advance.registeredFormCountryDisabled"
          >
            <b-form-group
              :description="fieldData.registeredAddressCountryHelperText[selectedLanguage]"
            >
              <label class="text-left">
                <span
                  v-if="fieldData.validation && fieldData.validation.isRequireRegistrationFormCountry"
                  class="required-span"
                >*</span>
                {{fieldData.registeredAddressCountryLabel[selectedLanguage]}}
              </label>

              <v-select
                :disabled="isDisabled == 1 || isNa == 1"
                label="name"
                v-model="$v.registrationForm.country.$model"
                :state="$v.registrationForm && $v.registrationForm.country.$dirty ? !$v.registrationForm.country.$error : null"
                :options="optionsCountries"
                :class="$v.registrationForm.country.$error ? 'border border-danger rounded' : null"
                @input="onSelectedRegistrationForm"
                @blur.native="$v.registrationForm.$touch()"
              >
                <template slot="option" slot-scope="option">
                  <country-flag v-if="option.icon" :country="option.icon" size="small" />
                  <span>{{ '&nbsp;'+ option.name }}</span>
                </template>
              </v-select>
              <label
                v-if="$v.registrationForm.country.$error && fieldData.validation.isRequireRegistrationFormCountry && !registrationForm.country"
                class="text-danger"
                style="font-size: 80%;"
              >{{fieldData.registeredAddressCountryValidationMessage[selectedLanguage]}}</label>
            </b-form-group>
          </div>
          <div
            class="col-md-6"
            v-show="!fieldData.advance || !fieldData.advance.registeredFormCityDisabled"
          >
            <b-form-group
              :description="fieldData.registeredAddressUsStateHelperText[selectedLanguage]"
              v-if="isUsSelected"
            >
              <label class="text-left">
                <span
                  v-if="fieldData.validation && fieldData.validation.isRequireRegistrationFormUsState"
                  class="required-span"
                >*</span>
                {{fieldData.registeredAddressUsStateLabel[selectedLanguage]}}
              </label>
              <v-select
                :disabled="isDisabled == 1 || fieldData.isNa == 1"
                label="name"
                v-model="$v.registrationForm.usState.$model"
                :state="$v.registrationForm && $v.registrationForm.usState.$dirty ? !$v.registrationForm.usState.$error : null"
                :options="usStates"
                :class="$v.registrationForm.usState.$error ? 'border border-danger rounded' : null"
                @input="onSelectRegistrationFormUsState"
                @blur.native="$v.registrationForm.$touch()"
              >
                <template slot="option" slot-scope="option">
                  <country-flag v-if="option.icon" :country="option.icon" size="small" />
                  <span>{{ '&nbsp;'+ option.name }}</span>
                </template>
              </v-select>
              <label
                v-if="$v.registrationForm.usState.$error && fieldData.validation.isRequireRegistrationFormUsState && !registrationForm.usState"
                class="text-danger"
                style="font-size: 80%;"
              >{{fieldData.registeredAddressUsStateValidationMessage[selectedLanguage]}}</label>
            </b-form-group>

            <b-form-group
              :description="fieldData.registeredAddressCityStateHelperText[selectedLanguage]"
              :invalid-feedback="msg.xssRegCityState ? $t('createProfile.invalidInputMessage') : fieldData.registeredAddressCityStateValidationMessage[selectedLanguage]"
              v-if="!isUsSelected"
            >
              <label class="text-left">
                <span
                  v-if="fieldData.validation && fieldData.validation.isRequireRegistrationFormCity"
                  class="required-span"
                >*</span>
                {{fieldData.registeredAddressCityStateLabel[selectedLanguage]}}
              </label>
              <b-form-input
                :disabled="isDisabled == 1 || fieldData.isNa == 1"
                type="text"
                v-model="$v.registrationForm.cityState.$model"
                :placeholder="fieldData.registeredAddressCityStatePlaceholder[selectedLanguage]"
                :state="
                  msg.xssRegCityState
                    ? false
                    : $v.registrationForm && $v.registrationForm.cityState.$dirty
                    ? !$v.registrationForm.cityState.$error
                    : null
                "
                @input="onRegInput($event, 'xssRegCityState')"
                @blur.native="$v.registrationForm.$touch()"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <!-- ------------------------row 2 -------------------------------->
        <div class="form-row" :id="fieldData.id">
          <div
            class="col-md-6"
            v-show="!fieldData.advance || !fieldData.advance.registeredFormAddress1Disabled"
          >
            <b-form-group
              :description="fieldData.registeredAddressLine1HelperText[selectedLanguage]"
              :invalid-feedback="msg.xssRegAddress ? $t('createProfile.invalidInputMessage') : fieldData.registeredAddressLine1ValidationMessage[selectedLanguage]"
            >
              <label class="text-left">
                <span
                  v-if="fieldData.validation && fieldData.validation.isRequireRegistrationFormAddress1"
                  class="required-span"
                >*</span>
                {{fieldData.registeredAddressLine1Label[selectedLanguage]}}
              </label>
              <b-form-input
                :disabled="isDisabled == 1 || fieldData.isNa == 1"
                v-model="$v.registrationForm.address.$model"
                :placeholder="fieldData.registeredAddressLine1Placeholder[selectedLanguage]"
                :state="
                  msg.xssRegAddress
                    ? false
                    : $v.registrationForm && $v.registrationForm.address.$dirty
                    ? !$v.registrationForm.address.$error
                    : null
                "
                @input="onRegInput($event, 'xssRegAddress')"
                @blur.native="$v.registrationForm.$touch()"
              ></b-form-input>
            </b-form-group>
          </div>
          <div
            class="col-md-6"
            v-show="!fieldData.advance || !fieldData.advance.registeredFormAddress2Disabled"
          >
            <b-form-group
              :description="fieldData.registeredAddressLine2HelperText[selectedLanguage]"
              :invalid-feedback="msg.xssRegAddressTwo ? $t('createProfile.invalidInputMessage') : fieldData.registeredAddressLine2ValidationMessage[selectedLanguage]"
            >
              <label class="text-left">
                <span
                  v-if="fieldData.validation && fieldData.validation.isRequireRegistrationFormAddress2"
                  class="required-span"
                >*</span>
                {{fieldData.registeredAddressLine2Label[selectedLanguage]}}
              </label>
              <b-form-input
                :disabled="isDisabled == 1 || fieldData.isNa == 1"
                type="text"
                v-model="$v.registrationForm.addressTwo.$model"
                :placeholder="fieldData.registeredAddressLine2Placeholder[selectedLanguage]"
                :state="
                  msg.xssRegAddressTwo
                    ? false
                    : $v.registrationForm && $v.registrationForm.addressTwo.$dirty
                    ? !$v.registrationForm.addressTwo.$error
                    : null
                "
                @input="onRegInput($event, 'xssRegAddressTwo')"
                @blur.native="$v.registrationForm.$touch()"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <!-- ------------------------row 3 -------------------------------->
        <div class="form-row">
          <div
            class="col-md-6"
            v-show="!fieldData.advance || !fieldData.advance.registeredFormTownDisabled"
          >
            <b-form-group
              :description="fieldData.registeredAddressTownHelperText[selectedLanguage]"
              :invalid-feedback="msg.xssRegTown ? $t('createProfile.invalidInputMessage') : fieldData.registeredAddressTownValidationMessage[selectedLanguage]"
            >
              <label class="text-left">
                <span
                  v-if="fieldData.validation && fieldData.validation.isRequireRegistrationFormTown"
                  class="required-span"
                >*</span>
                {{fieldData.registeredAddressTownLabel[selectedLanguage]}}
              </label>
              <b-form-input
                :disabled="isDisabled == 1 || fieldData.isNa == 1"
                type="text"
                v-model="$v.registrationForm.town.$model"
                :placeholder="fieldData.registeredAddressTownPlaceholder[selectedLanguage]"
                :state="
                  msg.xssRegTown
                    ? false
                    : $v.registrationForm && $v.registrationForm.town.$dirty
                    ? !$v.registrationForm.town.$error
                    : null
                "
                @input="onRegInput($event, 'xssRegTown')"
                @blur.native="$v.registrationForm.$touch()"
              ></b-form-input>
            </b-form-group>
          </div>
          <div
            class="col-md-6"
            v-show="!fieldData.advance || !fieldData.advance.registeredFormZipDisabled"
          >
            <b-form-group
              :description="fieldData.registeredAddressPostalZipCodeHelperText[selectedLanguage]"
              :invalid-feedback="msg.xssRegZipCode ? $t('createProfile.invalidInputMessage') : fieldData.registeredAddressPostalZipCodeValidationMessage[selectedLanguage]"
            >
              <label class="text-left">
                <span
                  v-if="fieldData.validation && fieldData.validation.isRequireRegistrationFormZip"
                  class="required-span"
                >*</span>
                {{fieldData.registeredAddressPostalZipCodeLabel[selectedLanguage]}}
              </label>
              <b-form-input
                :disabled="isDisabled == 1 || fieldData.isNa == 1"
                type="text"
                v-model="$v.registrationForm.zipCode.$model"
                :placeholder="fieldData.registeredAddressPostalZipCodePlaceholder[selectedLanguage]"
                :state="
                  msg.xssRegZipCode
                    ? false
                    : $v.registrationForm && $v.registrationForm.zipCode.$dirty
                    ? !$v.registrationForm.zipCode.$error
                    : null
                "
                @input="onRegInput($event, 'xssRegZipCode')"
                @blur.native="$v.registrationForm.$touch()"
                id="inputZip"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <!-- ------------------------row 4 -------------------------------->
        <div class="form-row" v-if="showFreeForm">
          <div
            class="col-md-6"
            v-show="!fieldData.advance || !fieldData.advance.registrationFormFreeFormDisabled"
          >
            <b-form-group
              :description="fieldData.registrationFormFreeFormHelperText[selectedLanguage]"
              :invalid-feedback="msg.xssRegFreeForm ? $t('createProfile.invalidInputMessage') : fieldData.registrationFormFreeFormValidationMessage[selectedLanguage]"
            >
              <label class="text-left">
                <span
                  v-if="fieldData.validation && JSON.parse(fieldData.validation.isRequireRegistrationFreeForm)"
                  class="required-span"
                >*</span>
                {{fieldData.registrationFormFreeFormLabel[selectedLanguage]}}
              </label>
              <b-form-input
                :disabled="isDisabled == 1 || fieldData.isNa == 1"
                v-model="$v.registrationForm.freeForm.$model"
                :placeholder="fieldData.registrationFormFreeFormPlaceholderText[selectedLanguage]"
                :state="
                  msg.xssRegFreeForm
                    ? false
                    : $v.registrationForm && $v.registrationForm.freeForm.$dirty
                    ? !$v.registrationForm.freeForm.$error
                    : null
                "
                @input="onRegInput($event, 'xssRegFreeForm')"
                @blur.native="$v.registrationForm.$touch()"
                type="text"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>

      <div
        :class="$store.state.rightAlign ? 'card-body text-right' : 'card-body text-left'"
        :id="fieldData.id"
      >
        <b-form-checkbox
          value="1"
          unchecked-value="0"
          :disabled="isDisabled == 1"
          v-model="tradingAndRegisteredAddressIsSame"
          @input="onCheckSameAddress"
        >{{fieldData.checkBoxLabel[selectedLanguage]}}</b-form-checkbox>

        <!-- ----------------------------------Tradiung addresss------------------------------------------- -->
        <!-- v-if="!tradingAndRegisteredAddressIsSame" -->
        <div>
          <h4
            :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
          >{{fieldData.tradingLabel[selectedLanguage]}}</h4>
          <p
            :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
          >{{fieldData.tradingDescription[selectedLanguage]}}</p>
          <!-- <h2>Trading Address</h2> -->

          <!-- ------------------------row 1 -------------------------------->

          <div class="form-row">
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.tradingFormCountryDisabled"
            >
              <b-form-group
                :description="fieldData.tradingAddressAddressCountryHelperText[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && fieldData.validation.isRequireTradingFormCountry"
                    class="required-span"
                  >*</span>
                  {{fieldData.tradingAddressCountryLabel[selectedLanguage]}}
                </label>
                <v-select
                  :disabled="isDisabled == 1 || tradingAndRegisteredAddressIsSame != 0"
                  label="name"
                  v-model="$v.tradingForm.country.$model"
                  :state="$v.tradingForm && $v.tradingForm.country.$dirty ? !$v.tradingForm.country.$error : null"
                  :options="optionsCountries"
                  :class="$v.tradingForm.country.$error ? 'border border-danger rounded' : null"
                  @input="onSelectedTradingForm"
                  @blur.native="$v.tradingForm.$touch()"
                >
                  <template slot="option" slot-scope="option">
                    <country-flag v-if="option.icon" :country="option.icon" size="small" />
                    <span>{{ '&nbsp;'+ option.name }}</span>
                  </template>
                </v-select>
                <label
                  v-if="$v.tradingForm.country.$error && fieldData.validation.isRequireTradingFormCountry && !tradingForm.country"
                  class="text-danger"
                  style="font-size: 80%;"
                >{{fieldData.tradingAddressAddressCountryValidationMessage[selectedLanguage]}}</label>
              </b-form-group>
            </div>
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.tradingFormCityDisabled"
            >
              <b-form-group
                :description="fieldData.tradingAddressUsStateHelperText[selectedLanguage]"
                v-if="isUsSelected"
              >
                <label>
                  <span
                    v-if="fieldData.validation && fieldData.validation.isRequireTradingFormUsState"
                    class="required-span"
                  >*</span>
                  {{fieldData.tradingAddressUsStateLabel[selectedLanguage]}}
                </label>
                <v-select
                  :disabled="isDisabled == 1 || tradingAndRegisteredAddressIsSame != 0"
                  label="name"
                  v-model="$v.tradingForm.usState.$model"
                  :state="$v.tradingForm && $v.tradingForm.usState.$dirty ? !$v.tradingForm.usState.$error : null"
                  :options="usStates"
                  :class="$v.tradingForm.usState.$error ? 'border border-danger rounded' : null"
                  @input="onSelectTradingFormUsState"
                  @blur.native="$v.tradingForm.$touch()"
                >
                  <template slot="option" slot-scope="option">
                    <country-flag v-if="option.icon" :country="option.icon" size="small" />
                    <span>{{ '&nbsp;'+ option.name }}</span>
                  </template>
                </v-select>
                <label
                  v-if="$v.tradingForm.usState.$error && fieldData.validation.isRequireTradingFormUsState && !tradingForm.usState"
                  class="text-danger"
                  style="font-size: 80%;"
                >{{fieldData.tradingAddressUsStateValidationMessage[selectedLanguage]}}</label>
              </b-form-group>

              <b-form-group
                :disabled="tradingAndRegisteredAddressIsSame != 0"
                :description="fieldData.tradingAddressAddressCityStateHelperText[selectedLanguage]"
                :invalid-feedback="msg.xssTradeCityState ? $t('createProfile.invalidInputMessage') : fieldData.tradingAddressAddressCityStateValidationMessage[selectedLanguage]"
                v-if="!isUsSelected"
              >
                <label>
                  <span
                    v-if="fieldData.validation && fieldData.validation.isRequireTradingFormCity"
                    class="required-span"
                  >*</span>
                  {{fieldData.tradingAddressCityStateLabel[selectedLanguage]}}
                </label>
                <b-form-input
                  :disabled="isDisabled == 1"
                  type="text"
                  v-model="$v.tradingForm.cityState.$model"
                  :placeholder="fieldData.tradingAddressCityStatePlaceholder[selectedLanguage]"
                  :state="
                    msg.xssTradeCityState
                      ? false
                      : $v.tradingForm && $v.tradingForm.cityState.$dirty
                      ? !$v.tradingForm.cityState.$error
                      : null
                  "
                  @input="checkXss('xssTradeCityState', $event)"
                  @blur.native="$v.tradingForm.$touch()"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

          <!-- ------------------------row 2 -------------------------------->

          <div class="form-row">
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.tradingFormAddress1Disabled"
            >
              <b-form-group
                :disabled="tradingAndRegisteredAddressIsSame != 0"
                :description="fieldData.tradingAddressAddressLine1HelperText[selectedLanguage]"
                :invalid-feedback="msg.xssTradeAddress ? $t('createProfile.invalidInputMessage') : fieldData.tradingAddressAddressLine1ValidationMessage[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && fieldData.validation.isRequireTradingFormAddress1"
                    class="required-span"
                  >*</span>
                  {{fieldData.tradingAddressLine1Label[selectedLanguage]}}
                </label>
                <b-form-input
                  :disabled="isDisabled == 1"
                  type="text"
                  v-model="$v.tradingForm.address.$model"
                  :placeholder="fieldData.tradingAddressLine1Placeholder[selectedLanguage]"
                  :state="
                    msg.xssTradeAddress
                      ? false
                      : $v.tradingForm && $v.tradingForm.address.$dirty
                      ? !$v.tradingForm.address.$error
                      : null
                  "
                  @input="checkXss('xssTradeAddress', $event)"
                  @blur.native="$v.tradingForm.$touch()"
                ></b-form-input>
              </b-form-group>
            </div>
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.tradingFormAddress2Disabled"
            >
              <b-form-group
                :disabled="tradingAndRegisteredAddressIsSame != 0"
                :description="fieldData.tradingAddressAddressLine2HelperText[selectedLanguage]"
                :invalid-feedback="msg.xssTradeAddressTwo ? $t('createProfile.invalidInputMessage') : fieldData.tradingAddressAddressLine2ValidationMessage[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && fieldData.validation.isRequireTradingFormAddress2"
                    class="required-span"
                  >*</span>
                  {{fieldData.tradingAddressLine2Label[selectedLanguage]}}
                </label>
                <b-form-input
                  :disabled="isDisabled == 1"
                  type="text"
                  v-model="$v.tradingForm.addressTwo.$model"
                  :placeholder="fieldData.tradingAddressLine2Placeholder[selectedLanguage]"
                  :state="
                    msg.xssTradeAddressTwo
                      ? false
                      : $v.tradingForm && $v.tradingForm.addressTwo.$dirty
                      ? !$v.tradingForm.addressTwo.$error
                      : null
                  "
                  @input="checkXss('xssTradeAddressTwo', $event)"
                  @blur.native="$v.tradingForm.$touch()"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

          <!-- ------------------------row 3 -------------------------------->
          <div class="form-row">
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.tradingFormTownDisabled"
            >
              <b-form-group
                :disabled="tradingAndRegisteredAddressIsSame != 0"
                :description="fieldData.tradingAddressAddressTownHelperText[selectedLanguage]"
                :invalid-feedback="msg.xssTradeTown ? $t('createProfile.invalidInputMessage') : fieldData.tradingAddressAddressTownValidationMessage[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && fieldData.validation.isRequireTradingFormTown"
                    class="required-span"
                  >*</span>
                  {{fieldData.tradingAddressTownLabel[selectedLanguage]}}
                </label>
                <b-form-input
                  :disabled="isDisabled == 1"
                  type="text"
                  v-model="$v.tradingForm.town.$model"
                  :placeholder="fieldData.tradingAddressTownPlaceholder[selectedLanguage]"
                  :state="
                    msg.xssTradeTown
                      ? false
                      : $v.tradingForm && $v.tradingForm.town.$dirty
                      ? !$v.tradingForm.town.$error
                      : null
                  "
                  @input="checkXss('xssTradeTown', $event)"
                  @blur.native="$v.tradingForm.$touch()"
                ></b-form-input>
              </b-form-group>
            </div>
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.tradingFormZipDisabled"
            >
              <b-form-group
                :disabled="tradingAndRegisteredAddressIsSame != 0"
                :description="fieldData.tradingAddressAddressPostalZipCodeHelperText[selectedLanguage]"
                :invalid-feedback="msg.xssTradeZipCode ? $t('createProfile.invalidInputMessage') : fieldData.tradingAddressAddressPostalZipCodeValidationMessage[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && fieldData.validation.isRequireTradingFormZip"
                    class="required-span"
                  >*</span>
                  {{fieldData.tradingAddressPostalZipCodeLabel[selectedLanguage]}}
                </label>
                <b-form-input
                  :disabled="isDisabled == 1"
                  type="text"
                  v-model="$v.tradingForm.zipCode.$model"
                  :placeholder="fieldData.tradingAddressPostalZipCodePlaceholder[selectedLanguage]"
                  :state="
                    msg.xssTradeZipCode
                      ? false
                      : $v.tradingForm && $v.tradingForm.zipCode.$dirty
                      ? !$v.tradingForm.zipCode.$error
                      : null
                  "
                  @input="checkXss('xssTradeZipCode', $event)"
                  @blur.native="$v.tradingForm.$touch()"
                  id="inputZip"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

          <!-- ------------------------row 4 -------------------------------->
          <div class="form-row" v-if="showFreeForm">
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.tradingFormFreeFormDisabled"
            >
              <b-form-group
                :description="fieldData.tradingFormFreeFormHelperText[selectedLanguage]"
                :invalid-feedback="msg.xssTradeFreeForm ? $t('createProfile.invalidInputMessage') : fieldData.tradingFormFreeFormValidationMessage[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && JSON.parse(fieldData.validation.isRequireTradingFreeForm)"
                    class="required-span"
                  >*</span>
                  {{fieldData.tradingFormFreeFormLabel[selectedLanguage]}}
                </label>
                <b-form-input
                  :disabled="isDisabled == 1"
                  v-model="$v.tradingForm.freeForm.$model"
                  :placeholder="fieldData.tradingFormFreeFormPlaceholderText[selectedLanguage]"
                  :state="
                    msg.xssTradeFreeForm
                      ? false
                      : $v.tradingForm && $v.tradingForm.freeForm.$dirty
                      ? !$v.tradingForm.freeForm.$error
                      : null
                  "
                  @input="checkXss('xssTradeFreeForm', $event)"
                  @blur.native="$v.tradingForm.$touch()"
                  type="text"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <!-- show advance field options -->
      <b-modal
        cancel-title="Close"
        ok-title="save"
        @ok="onSaveData"
        size="xl"
        v-model="showSettings"
        scrollable
        title="Advanced Settings"
      >
        <AdvanceSettings
          :fieldData="fieldData"
          v-on:toggle-field="showSettings=!showSettings"
          :sectionIndex="sectionIndex"
          :fieldIndex="fieldIndex"
        />
      </b-modal>
    </b-collapse>
  </div>
</template>

<script>
import MenuButtons from "../menuButtons";
import AdvanceSettings from "../workflowSettings/advanceCorporateAddressSettings.vue";
import vSelect from "vue-select";
import CountryCodes from "../../utils/countryCodes.json";
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import { EventBus } from "@/event-bus.js";
import { Helper, Validate } from "../../helpers";
import _ from "lodash";

export default {
  name: "AddressCorporateGroup",
  mixins: [validationMixin],
  components: {
    MenuButtons,
    AdvanceSettings,
    vSelect,
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage"]),
  },
  data() {
    return {
      isNa: this.fieldData.isNa || 0,
      showFreeForm: false,
      optionsCountries: CountryCodes.countries,
      usStates: [],
      isHidden: false,
      condition: {},
      title: null,
      isUsSelected: false,
      registrationForm: {
        address: null,
        addressTwo: null,
        town: null,
        cityState: null,
        usState: null,
        zipCode: null,
        country: null,
        freeForm: null,
      },
      tradingForm: {
        address: null,
        addressTwo: null,
        town: null,
        cityState: null,
        usState: null,
        zipCode: null,
        country: null,
        freeForm: null,
      },
      tradingAndRegisteredAddressIsSame: 0,
      label: null,
      showSettings: false,
      collapse: true,
      postData: [],
      msg: {},
    };
  },

  validations() {
    return {
      registrationForm: {
        address: {
          [this.address]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireRegistrationFormAddress1
              ? required
              : !required,
        },
        addressTwo: {
          [this.addressTwo]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireRegistrationFormAddress2
              ? required
              : !required,
        },
        town: {
          [this.town]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireRegistrationFormTown
              ? required
              : !required,
        },
        cityState: {
          [this.cityState]:
            !this.isUsSelected &&
            this.fieldData.validation &&
            this.fieldData.validation.isRequireRegistrationFormCity
              ? required
              : !required,
        },
        zipCode: {
          [this.zipCode]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireRegistrationFormZip
              ? required
              : !required,
        },
        country: {
          [this.country]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireRegistrationFormCountry
              ? required
              : !required,
        },
        usState: {
          [this.usState]:
            this.isUsSelected &&
            this.fieldData.validation &&
            this.fieldData.validation.isRequireRegistrationFormUsState
              ? required
              : !required,
        },
        freeForm: {
          [this.freeForm]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireRegistrationFreeForm
              ? required
              : !required,
        },
      },

      // ----form two
      tradingForm: {
        address: {
          [this.address]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireTradingFormAddress1
              ? required
              : !required,
        },
        addressTwo: {
          [this.addressTwo]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireTradingFormAddress2
              ? required
              : !required,
        },
        town: {
          [this.town]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireTradingFormTown
              ? required
              : !required,
        },
        cityState: {
          [this.cityState]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireTradingFormCity
              ? required
              : !required,
        },
        zipCode: {
          [this.zipCode]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireTradingFormZip
              ? required
              : !required,
        },
        country: {
          [this.country]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireTradingFormCountry
              ? required
              : !required,
        },
        usState: {
          [this.usState]:
            this.isUsSelected &&
            this.fieldData.validation &&
            this.fieldData.validation.isRequireRegistrationFormUsState
              ? required
              : !required,
        },
        freeForm: {
          [this.freeForm]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireTradingFreeForm
              ? required
              : !required,
        },
      },
    };
  },

  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (this.hasActiveXssError()) {
        this.$store.state.validFields = false;
        this.fieldData.isInValid = true;
        return;
      }
      if (value == "progress" || this.fieldData.isNa == 1) {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
        this.setTempDataRegistration();
      } else if (this.fieldData.isHidden) {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
      } else {
        this.$v.registrationForm.$touch();
        if (
          this.$v &&
          this.$v.registrationForm.$anyError &&
          this.$v.registrationForm.$invalid
        ) {
          this.$store.state.validFields = false;
          this.fieldData.isInValid = true;
          return;
        } else {
          this.$store.state.validFields = true;
          this.fieldData.isInValid = false;
          this.setTempDataRegistration();
          // this.setTempDataTrade();
        }
      }
    });

    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (this.hasActiveXssError()) {
        this.$store.state.validFields = false;
        this.fieldData.isInValid = true;
        return;
      }
      if (value == "progress" || this.fieldData.isNa == 1) {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
        this.setTempDataTrade();
      } else if (this.fieldData.isHidden) {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
      } else {
        this.$v.tradingForm.$touch();
        this.$v.registrationForm.$touch();
        if (
          (this.$v &&
            this.$v.tradingForm.$anyError &&
            this.$v.tradingForm.$invalid) ||
          (this.$v.registrationForm.$anyError &&
            this.$v.registrationForm.$invalid)
        ) {
          this.$store.state.validFields = false;
          this.fieldData.isInValid = true;
          return;
        } else {
          this.$store.state.validFields = true;
          this.fieldData.isInValid = false;
          // this.setTempDataRegistration();
          this.setTempDataTrade();
        }
      }
    });

    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      // // console.log("OnInvalidFieldCatch radio", inValidData, this.fieldData.id)
      document
        .getElementById(inValidData.elementId)
        .scrollIntoView({ behavior: "smooth" });
    });
  },

  mounted() {
    // this.checkForConditional();
    this.setFreeFormFields();
    this.setNewConditions();
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeUserFormPage" ||
      this.$route.name == "EmployeeComplaintFormPage" ||
      this.$route.name == "ViewComplaints"
    ) {
      this.getDataForUser();
    }
  },
  
  methods: {
    checkXss(key, value) {
      this.msg[key] = !Validate.noXSS(value) ? true : false;
    },

    hasActiveXssError() {
      return Object.keys(this.msg).some((key) => key.startsWith("xss") && this.msg[key]);
    },

    onRegInput(value, key) {
      this.checkXss(key, value);
      this.checkFormProgress();
    },

    onClilckNa(e) {
      // console.log("onClilckNa", e);
      this.isNa = e;
      this.fieldData.isNa = e;
      if ((e = 1)) {
        this.resetForm();
      }
    },

    resetForm() {
      (this.registrationForm = {
        address: null,
        addressTwo: null,
        town: null,
        cityState: null,
        usState: null,
        zipCode: null,
        country: null,
        freeForm: null,
      }),
        (this.tradingForm = {
          address: null,
          addressTwo: null,
          town: null,
          cityState: null,
          usState: null,
          zipCode: null,
          country: null,
          freeForm: null,
        });
    },

    setFreeFormFields() {
      Object.assign(this.fieldData, {
        // registrationForm
        registrationFormFreeFormLabel: {
          english: "Free Form",
        },
        registrationFormFreeFormPlaceholderText: {
          english: "",
        },
        registrationFormFreeFormHelperText: {
          english: "",
        },
        registrationFormFreeFormValidationMessage: {
          english: "This field is required",
        },

        // tradingForm
        tradingFormFreeFormLabel: {
          english: "Free Form",
        },
        tradingFormFreeFormPlaceholderText: {
          english: "",
        },
        tradingFormFreeFormHelperText: {
          english: "",
        },
        tradingFormFreeFormValidationMessage: {
          english: "This field is required",
        },
      });
      let validation = {
        ...this.fieldData.validation,
        isRequireRegistrationFreeForm:
          this.fieldData.validation.isRequireRegistrationFreeForm || false,
        isRequireTradingFreeForm:
          this.fieldData.validation.isRequireTradingFreeForm || false,
      };
      Object.assign(this.fieldData, { validation });
      let advance = {
        ...this.fieldData.advance,
        registrationFormFreeFormDisabled:
          this.fieldData.advance.registrationFormFreeFormDisabled || true,
        tradingFormFreeFormDisabled:
          this.fieldData.advance.tradingFormFreeFormDisabled || true,
      };
      Object.assign(this.fieldData, { advance });
      this.showFreeForm = true;
    },

    setNewConditions() {
      Object.assign(this.fieldData, {
        isInValid: this.fieldData.isInValid || null,
      });
      Object.assign(this.fieldData, {
        isHidden: this.fieldData.isHidden || false,
      });
      Object.assign(this.fieldData, {
        isConditional: this.fieldData.isConditional || 0,
      });
      Object.assign(this.fieldData, {
        conditions:
          this.fieldData.conditions && this.fieldData.conditions.length
            ? this.fieldData.conditions
            : [],
      });
      Object.assign(this.fieldData, {
        conditionalFields:
          this.fieldData.conditionalFields &&
          this.fieldData.conditionalFields.length
            ? this.fieldData.conditionalFields
            : [],
      });
      Object.assign(this.fieldData, {
        sectionConditions:
          this.fieldData.sectionConditions &&
          this.fieldData.sectionConditions.length
            ? this.fieldData.sectionConditions
            : [],
      });
    },

    onSelectRegistrationFormUsState(value) {
      this.registrationForm.usState = value.name;
      this.checkFormProgress();
    },

    onSelectTradingFormUsState(value) {
      this.registrationForm.usState = value.name;
    },

    checkForUsStates(value) {
      // // console.log("onSelectedRegistrationForm", value);
      if (
        value == "United States" &&
        !this.fieldData.advance.registeredFormCityDisabled
      ) {
        this.isUsSelected = true;
      } else {
        this.isUsSelected = false;
      }
    },

    checkForConditional() {
      // console.log("checkForConditional corpoarte addrress ", this.fieldData.isConditional);
      if (this.fieldData.isConditional == 1) {
        this.fieldData.isHidden = false;
      }
    },

    onSelectedRegistrationForm(value) {
      // // console.log("onSelectedRegistrationForm", value);

      this.registrationForm.country = value.name;
      if (
        value.name == "United States" &&
        !this.fieldData.advance.registeredFormCityDisabled
      ) {
        this.isUsSelected = true;
        this.usStates = value.states;
      } else {
        this.isUsSelected = false;
      }
    },

    onSelectedTradingForm(value) {
      this.tradingForm.country = value.name;
      if (
        value.name == "United States" &&
        !this.fieldData.advance.tradingFormCityDisabled
      ) {
        this.isUsSelected = true;
        this.usStates = value.states;
      } else {
        this.isUsSelected = false;
      }
    },

    onCheckSameAddress() {
      if (this.tradingAndRegisteredAddressIsSame != 0) {
        (this.tradingForm.address = this.registrationForm.address),
          (this.tradingForm.addressTwo = this.registrationForm.addressTwo),
          (this.tradingForm.town = this.registrationForm.town),
          (this.tradingForm.cityState = this.registrationForm.cityState),
          (this.tradingForm.usState = this.registrationForm.usState),
          (this.tradingForm.zipCode = this.registrationForm.zipCode),
          (this.tradingForm.country = this.registrationForm.country),
          (this.tradingForm.freeForm = this.registrationForm.freeForm);

        this.checkXss("xssTradeAddress", this.tradingForm.address);
        this.checkXss("xssTradeAddressTwo", this.tradingForm.addressTwo);
        this.checkXss("xssTradeTown", this.tradingForm.town);
        this.checkXss("xssTradeCityState", this.tradingForm.cityState);
        this.checkXss("xssTradeZipCode", this.tradingForm.zipCode);
        this.checkXss("xssTradeFreeForm", this.tradingForm.freeForm);
      } else {
        (this.tradingForm.address = null),
          (this.tradingForm.addressTwo = null),
          (this.tradingForm.town = null),
          (this.tradingForm.cityState = null),
          (this.tradingForm.usState = null),
          (this.tradingForm.zipCode = null),
          (this.tradingForm.country = null),
          (this.tradingForm.freeForm = null);
      }
    },

    getDataForUser() {
      this.$store.state.getUserFormSubmitArray.map((data) => {
        if (data.elements && data.elements.length > 0) {
          data.elements.map((element, index) => {
            if (data.elementId === this.fieldData.id) {
              console.log("Corporate address data foondt --------------");
              this.fieldData.isNa = data.isWorkFlowNa;
              if (element[0].reg) {
                (this.registrationForm.address =
                  element[
                    element.findIndex((x) => x.key == "regAddress")
                  ].postValue),
                  (this.registrationForm.addressTwo =
                    element[
                      element.findIndex((x) => x.key == "regAddressTwo")
                    ].postValue),
                  (this.registrationForm.town =
                    element[
                      element.findIndex((x) => x.key == "regTown")
                    ].postValue);
                this.registrationForm.cityState =
                  element[
                    element.findIndex((x) => x.key == "regCityState")
                  ].postValue;
                this.registrationForm.usState =
                  element[
                    element.findIndex((x) => x.key == "regUsState")
                  ].postValue;
                this.registrationForm.zipCode =
                  element[
                    element.findIndex((x) => x.key == "regZipCode")
                  ].postValue;
                this.registrationForm.country =
                  element[
                    element.findIndex((x) => x.key == "regCountry")
                  ].postValue;
                this.registrationForm.freeForm =
                  element[
                    element.findIndex((x) => x.key == "regFreeForm")
                  ].postValue;

                if (data.isSameAsRegistration == 1) {
                  let cloneAddress = _.cloneWith(this.registrationForm);
                  this.tradingAndRegisteredAddressIsSame = 1;
                  this.tradingForm = cloneAddress;
                }

                this.checkForUsStates(this.registrationForm.country);
              } else if (!element[1].reg) {
                (this.tradingForm.address =
                  element[
                    element.findIndex((x) => x.key == "address")
                  ].postValue),
                  (this.tradingForm.addressTwo =
                    element[
                      element.findIndex((x) => x.key == "addressTwo")
                    ].postValue),
                  (this.tradingForm.town =
                    element[
                      element.findIndex((x) => x.key == "town")
                    ].postValue);
                this.tradingForm.cityState =
                  element[
                    element.findIndex((x) => x.key == "cityState")
                  ].postValue;
                this.tradingForm.usState =
                  element[
                    element.findIndex((x) => x.key == "usState")
                  ].postValue;
                this.tradingForm.zipCode =
                  element[
                    element.findIndex((x) => x.key == "zipCode")
                  ].postValue;
                this.tradingForm.country =
                  element[
                    element.findIndex((x) => x.key == "country")
                  ].postValue;
                this.tradingForm.freeForm =
                  element[
                    element.findIndex((x) => x.key == "freeForm")
                  ].postValue;
              }
            }
          });
        }
      });
    },

    setDataToUser() {
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        this.$store.state.userFormSubmitArray.map((a, index) => {
          if (a.elementId === this.fieldData.id) {
            console.log("found corporate-address");
            a.isWorkFlowNa = this.fieldData.isNa;
            a.elements = this.postData;
            a.isSameAsRegistration = this.tradingAndRegisteredAddressIsSame;
            a.registeredLabel = this.fieldData.registeredLabel[
              this.selectedLanguage
            ];
            a.tradingLabel = this.fieldData.tradingLabel[this.selectedLanguage];
          }
        });
      }
    },

    setTempDataRegistration() {
      // this.postData[0] = []
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        let aa = [
          {
            reg: true,
            postValue: this.msg.xssRegAddress ? "" : this.registrationForm.address,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.address1PostName) ||
              "addressPostName",
            key: "regAddress",
            label: this.fieldData.registeredAddressLine1Label[
              this.selectedLanguage
            ],
          },
          {
            reg: true,
            postValue: this.msg.xssRegAddressTwo ? "" : this.registrationForm.addressTwo,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.address2PostName) ||
              "regAddressTwoPostName",
            key: "regAddressTwo",
            label: this.fieldData.registeredAddressLine2Label[
              this.selectedLanguage
            ],
          },
          {
            reg: true,
            postValue: this.msg.xssRegTown ? "" : this.registrationForm.town,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.townPostName) ||
              "regTownPostName",
            key: "regTown",
            label: this.fieldData.registeredAddressTownLabel[
              this.selectedLanguage
            ],
          },
          {
            reg: true,
            postValue: this.registrationForm.usState,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.usStatePostName) ||
              "regUsStatePostName",
            key: "regUsState",
            label: this.fieldData.registeredAddressUsStateLabel[
              this.selectedLanguage
            ],
          },
          {
            reg: true,
            postValue: this.msg.xssRegCityState ? "" : this.registrationForm.cityState,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.cityPostName) ||
              "regCityStatePostName",
            key: "regCityState",
            label: this.fieldData.registeredAddressCityStateLabel[
              this.selectedLanguage
            ],
          },
          {
            reg: true,
            postValue: this.msg.xssRegZipCode ? "" : this.registrationForm.zipCode,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.zipPostName) ||
              "regZipCodePostName",
            key: "regZipCode",
            label: this.fieldData.registeredAddressPostalZipCodeLabel[
              this.selectedLanguage
            ],
          },
          {
            reg: true,
            postValue: this.registrationForm.country,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.countryPostName) ||
              "regCountryPostName",
            key: "regCountry",
            label: this.fieldData.registeredAddressCountryLabel[
              this.selectedLanguage
            ],
          },
          {
            reg: true,
            postValue: this.msg.xssRegFreeForm ? "" : this.registrationForm.freeForm,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.freeFormPostName) ||
              "regFreeFormPostName",
            key: "regFreeForm",
            label: this.fieldData.registrationFormFreeFormLabel[
              this.selectedLanguage
            ],
          },
        ];
        this.postData[0] = aa;
        // console.log("this.postData", aa);
        this.setDataToUser();
      }
    },

    setTempDataTrade() {
      // this.postData[1] = []
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        let aa = [
          {
            postValue: this.msg.xssTradeAddress ? "" : this.tradingForm.address,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.addressPostName) ||
              "addressPostName",
            key: "address",
            label: this.fieldData.tradingAddressLine1Label[
              this.selectedLanguage
            ],
          },
          {
            postValue: this.msg.xssTradeAddressTwo ? "" : this.tradingForm.addressTwo,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.addressTwoPostName) ||
              "addressTwoPostName",
            key: "addressTwo",
            label: this.fieldData.tradingAddressLine2Label[
              this.selectedLanguage
            ],
          },
          {
            postValue: this.msg.xssTradeTown ? "" : this.tradingForm.town,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.townPostName) ||
              "townPostName",
            key: "town",
            label: this.fieldData.tradingAddressTownLabel[
              this.selectedLanguage
            ],
          },
          {
            postValue: this.tradingForm.usState,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.cityStatePostName) ||
              "usStatePostName",
            key: "usState",
            label: this.fieldData.tradingAddressUsStateLabel[
              this.selectedLanguage
            ],
          },
          {
            postValue: this.msg.xssTradeCityState ? "" : this.tradingForm.cityState,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.cityStatePostName) ||
              "cityStatePostName",
            key: "cityState",
            label: this.fieldData.tradingAddressCityStateLabel[
              this.selectedLanguage
            ],
          },
          {
            postValue: this.msg.xssTradeZipCode ? "" : this.tradingForm.zipCode,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.zipCodePostName) ||
              "zipCodePostName",
            key: "zipCode",
            label: this.fieldData.tradingAddressPostalZipCodeLabel[
              this.selectedLanguage
            ],
          },
          {
            postValue: this.tradingForm.country,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.countryPostName) ||
              "countryPostName",
            key: "country",
            label: this.fieldData.tradingAddressCountryLabel[
              this.selectedLanguage
            ],
          },
          {
            postValue: this.msg.xssTradeFreeForm ? "" : this.tradingForm.freeForm,
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.freeFormPostName) ||
              "freeFormPostName",
            key: "freeForm",
            label: this.fieldData.tradingFormFreeFormLabel[
              this.selectedLanguage
            ],
          },
        ];
        this.postData[1] = aa;
        this.setDataToUser();
      }
    },

    checkFormProgress() {
      const registerData = _.clone(this.$store.state.registerData);

      // if(tradingAndRegisteredAddressIsSame){}

      if (
        this.$v.registrationForm.$anyError &&
        this.$v.registrationForm.$invalid
      ) {
        delete registerData[this.fieldData.id];
        this.$store.state.registerData = registerData;
      } else {
        registerData[this.fieldData.id] = "address-corporate";
        this.$store.state.registerData = registerData;
      }
      const numkeys = Object.keys(registerData).length;
      // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
      this.$store.state.progressValue = numkeys;
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
      Helper.makeToast(this.$bvToast, "success", "Settings updated");
    },

    setValidation() {
      let validation = {
        isRequireRegistrationFormCountry: true,
        isRequireRegistrationFormCity: true,
        isRequireRegistrationFormUsState: true,
        isRequireRegistrationFormAddress1: true,
        isRequireRegistrationFormAddress2: true,
        isRequireRegistrationFormTown: true,
        isRequireRegistrationFormZip: true,

        isRequireTradingFormCountry: false,
        isRequireTradingFormCity: false,
        isRequireTradingFormUsState: false,
        isRequireTradingFormAddress1: false,
        isRequireTradingFormAddress2: false,
        isRequireTradingFormTown: false,
        isRequireTradingFormZip: false,
      };
      Object.assign(this.fieldData, { validation });
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>

<style>
/* .v-select-toggle[data-v-138dff1d] {
  border: 1px solid #d3d9df;
  background-color: white;
  height: 40px;
}
.v-select.disabled .v-select-toggle[data-v-138dff1d] {
  background-color: #e9ecef !important;
  border: 1px solid #ced4da !important;
  height: 40px;
} */
</style>
